import React from 'react';
import {Checkbox} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const checkBoxStyles = theme => ({
    root: {
      '&$checked': {
        color: '#4C8B2B',
      },
    },
    checked: {},
   })

export const ChironCheckbox = withStyles(checkBoxStyles)(Checkbox);
